__turbopack_context__.v({
  "calculator_content": "styles-module-scss-module__0rDgVG__calculator_content",
  "calculator_header": "styles-module-scss-module__0rDgVG__calculator_header",
  "calculator_left": "styles-module-scss-module__0rDgVG__calculator_left",
  "calculator_right": "styles-module-scss-module__0rDgVG__calculator_right",
  "calculator_selector": "styles-module-scss-module__0rDgVG__calculator_selector",
  "condensed": "styles-module-scss-module__0rDgVG__condensed",
  "container": "styles-module-scss-module__0rDgVG__container",
  "disclaimer_content": "styles-module-scss-module__0rDgVG__disclaimer_content",
  "disclaimer_header": "styles-module-scss-module__0rDgVG__disclaimer_header",
  "disclaimer_section": "styles-module-scss-module__0rDgVG__disclaimer_section",
  "form_actions": "styles-module-scss-module__0rDgVG__form_actions",
  "form_inputs": "styles-module-scss-module__0rDgVG__form_inputs",
  "form_section": "styles-module-scss-module__0rDgVG__form_section",
  "grid_layout": "styles-module-scss-module__0rDgVG__grid_layout",
  "layout_inputs_focused": "styles-module-scss-module__0rDgVG__layout_inputs_focused",
  "layout_results_focused": "styles-module-scss-module__0rDgVG__layout_results_focused",
  "results_section": "styles-module-scss-module__0rDgVG__results_section",
});
